// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-root .leadfeed .combined-slider-wrapper {
  margin-bottom: 1.5em;
}
app-root .combined-slider-wrapper {
  will-change: opacity;
  animation: fade-in 0.4s ease-in backwards 1s;
}
app-root .combined-slider-wrapper > * {
  opacity: 0;
  visibility: hidden;
  transition: 0.4s opacity ease-in 0.2s;
}
app-root .combined-slider-wrapper.show > * {
  visibility: visible;
  opacity: 1;
}
app-root .combined-slider-wrapper .title {
  font-size: 16px;
  font-weight: 600;
}
@media (min-width: 600px) {
  app-root .combined-slider-wrapper .title {
    font-size: 20px;
  }
}
app-root .combined-slider {
  align-items: center;
  position: relative;
  display: flex;
  padding: 0 12px 0 24px;
}
app-root .combined-slider .MuiSlider-root {
  color: var(--primary);
}
app-root .combined-slider .MuiSlider-root .MuiSlider-rail {
  background-color: #dcdcdc;
  opacity: 1;
}
app-root .combined-slider .MuiSlider-root .MuiSlider-thumb {
  background-color: white;
  border: 3px solid currentColor;
}
app-root .combined-slider .MuiSlider-root .MuiSlider-thumb:hover {
  box-shadow: 0px 0px 0px 8px rgba(62, 62, 62, 0.16);
}
app-root .combined-slider .MuiSlider-root .MuiSlider-thumb.Mui-focusVisible {
  box-shadow: 0px 0px 0px 8px rgba(62, 62, 62, 0.16);
}
app-root .combined-slider .MuiSlider-root .MuiSlider-thumb.Mui-active {
  box-shadow: 0px 0px 0px 14px rgba(175, 35, 28, 0.16);
}
app-root .combined-slider .hb-input {
  position: static;
  flex-shrink: 0;
  /* Chrome, Safari, Edge, Opera */
  /* Firefox */
}
app-root .combined-slider .hb-input + span {
  flex-shrink: 0;
  margin-left: 4px;
}
app-root .combined-slider .hb-input input::-webkit-outer-spin-button,
app-root .combined-slider .hb-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
app-root .combined-slider .hb-input input[type='number'] {
  appearance: textfield;
  -moz-appearance: textfield;
}
app-root .combined-slider .hb-input.validation-wrapper input {
  background-color: transparent;
  border-color: transparent;
  width: 4.5ch;
  flex-shrink: 0;
  text-align: right;
  margin-left: 12px;
  padding: 0 2px;
}
app-root .combined-slider .hb-input.validation-wrapper input:hover {
  border-color: var(--hover-grey);
}
app-root .combined-slider .hb-input .error-message {
  position: absolute;
  right: 50%;
  transform: translateX(50%);
}
`, "",{"version":3,"sources":["webpack://./src/Views/FormSteps/Location/Base/CombinedSlider/CombinedSlider.less"],"names":[],"mappings":"AAEA;EAEI,oBAAA;AAFJ;AAAA;EAMI,oBAAA;EACA,4CAAA;AAHJ;AAII;EACE,UAAA;EACA,kBAAA;EACA,qCAAA;AAFN;AAII;EACE,mBAAA;EACA,UAAA;AAFN;AAbA;EAmBM,eAAA;EACA,gBAAA;AAHN;AAIM;EAAA;IACE,eAAA;EADN;AACF;AAtBA;EA4BI,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAHJ;AA5BA;EAkCM,qBAAA;AAHN;AA/BA;EAqCQ,yBAAA;EACA,UAAA;AAHR;AAnCA;EA0CQ,uBAAA;EACA,8BAAA;AAJR;AAMQ;EACE,kDAAA;AAJV;AAOQ;EACE,kDAAA;AALV;AAQQ;EACE,oDAAA;AANV;AAhDA;EA4DM,gBAAA;EACA,cAAA;EATJ,gCAAgC;EAChC,YAAY;AACd;AASM;EACE,cAAA;EACA,gBAAA;AAPR;AA1DA;;EAwEQ,wBAAA;EACA,SAAA;AAVR;AA/DA;EA8EQ,qBAAA;EACA,0BAAA;AAZR;AAiBM;EACE,6BAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAfR;AAiBQ;EACE,+BAAA;AAfV;AA/EA;EAmGQ,kBAAA;EACA,UAAA;EACA,0BAAA;AAjBR","sourcesContent":["@import '../../../../../Styles/mediaQueries.less';\n\napp-root {\n  .leadfeed .combined-slider-wrapper {\n    margin-bottom: 1.5em;\n  }\n\n  .combined-slider-wrapper {\n    will-change: opacity;\n    animation: fade-in 0.4s ease-in backwards 1s;\n    & > * {\n      opacity: 0;\n      visibility: hidden;\n      transition: 0.4s opacity ease-in 0.2s;\n    }\n    &.show > * {\n      visibility: visible;\n      opacity: 1;\n    }\n\n    .title {\n      font-size: 16px;\n      font-weight: 600;\n      @media @portraitTabletUp {\n        font-size: 20px;\n      }\n    }\n  }\n\n  .combined-slider {\n    align-items: center;\n    position: relative;\n    display: flex;\n    padding: 0 12px 0 24px;\n\n    .MuiSlider-root {\n      color: var(--primary);\n\n      .MuiSlider-rail {\n        background-color: #dcdcdc;\n        opacity: 1;\n      }\n\n      .MuiSlider-thumb {\n        background-color: white;\n        border: 3px solid currentColor;\n\n        &:hover {\n          box-shadow: 0px 0px 0px 8px rgb(62 62 62 / 16%);\n        }\n\n        &.Mui-focusVisible {\n          box-shadow: 0px 0px 0px 8px rgb(62 62 62 / 16%);\n        }\n\n        &.Mui-active {\n          box-shadow: 0px 0px 0px 14px rgb(175 35 28 / 16%);\n        }\n      }\n    }\n\n    .hb-input {\n      position: static;\n      flex-shrink: 0;\n\n      & + span {\n        flex-shrink: 0;\n        margin-left: 4px;\n      }\n\n      // hide arrows of number input\n      /* Chrome, Safari, Edge, Opera */\n      input::-webkit-outer-spin-button,\n      input::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n\n      /* Firefox */\n      input[type='number'] {\n        appearance: textfield;\n        -moz-appearance: textfield;\n      }\n\n      // `.validation-wrapper` matches the generic input selector so its 8px padding can't win and\n      // squeeze values like 0.5 / 0.25 into the unit label\n      &.validation-wrapper input {\n        background-color: transparent;\n        border-color: transparent;\n        width: 4.5ch;\n        flex-shrink: 0;\n        text-align: right;\n        margin-left: 12px;\n        padding: 0 2px;\n\n        &:hover {\n          border-color: var(--hover-grey);\n        }\n      }\n\n      .error-message {\n        position: absolute;\n        right: 50%;\n        transform: translateX(50%);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
